export const MINUTE_IN_MS = 1000 * 60;
export const DAY_IN_MS = MINUTE_IN_MS * 60 * 24;
